module.exports = __webpack_public_path__ + "static/media/appstore_screens.981eaef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/appstore_screens.png
// module id = 1640
// module chunks = 0